// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MessageProcessorBase } from './MessageProcessorBase';
import { SOAPRespMessage } from '../Messages/SOAPRespMessage';
export class SOAPMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        return [new SOAPRespMessage(fieldSet)];
    }
}
